import { ExclamationCircleIcon } from "@heroicons/react/solid";
import i18next from "i18next";
import React, { useState, useEffect, useRef, useMemo } from "react";
import PhoneInputWithCountry from "react-phone-number-input/react-hook-form";
import { isValidPhoneNumber } from "react-phone-number-input";
import {
  countriesAbbreviation,
  countriesLocalization,
} from "../../../helpers/options/countries";
import InputErrors from "../InputErrors";
import "react-phone-number-input/style.css";
import "./phone-input.css";

const COMMON_INPUT_CLASSES =
  "focus:ring-transparent focus:outline-none border-none focus:shadow-none focus:border-transparent disabled:bg-gray-100";

const CustomInput = React.forwardRef<HTMLInputElement>((props, ref) => {
  return (
    <div className="w-full min-w-[12rem]">
      <div>
        <input
          ref={ref}
          {...props}
          className={`block w-full pr-10 text-sm ${COMMON_INPUT_CLASSES}`}
        />
      </div>
    </div>
  );
});

type PhoneNumberInputProps = {
  control: { [key: string]: any };
  id?: string;
  label?: string;
  name?: string;
  placeholder?: string;
  schema: any;
  disabled?: boolean;
};

const PhoneNumberInput = (props: PhoneNumberInputProps) => {
  const { control, id, label, name, placeholder, schema, disabled } = props;

  const [error, setError] = useState<object>();
  useEffect(() => {
    setError(control.getFieldState(name).error);
  }, [control.getFieldState(name).error]);

  const isRequired = useMemo(() => {
    if (!!schema) {
      return !!schema["required"];
    }
    return false;
  }, [schema]);

  const currentLanguage = i18next.language === "en" ? "en" : "ar";

  return (
    <div className="w-full phone-input--component">
      <label className={"block text-sm font-medium text-gray-700"}>
        {`${label}${isRequired ? "*" : ""}`}
      </label>
      <div
        dir="ltr"
        className={`relative flex border border-gray-300 rounded-md shadow-sm mt-1 overflow-hidden group focus-within:border-brandblue-500 focus-within:ring-1 focus-within:ring-offset-gray-100 ${
          error
            ? "focus-within:ring-red-500"
            : "focus-within:ring-brandblue-500"
        }`}
      >
        <PhoneInputWithCountry
          className={`flex w-full ${!!disabled && "bg-gray-100"}`}
          disabled={!!disabled}
          id={id}
          labels={countriesLocalization[currentLanguage]}
          placeholder={placeholder}
          international
          name={name}
          control={control}
          rules={{
            validate: (val: any) =>
              isValidPhoneNumber(val) ||
              i18next.t("errors.input.mobileNotValid"),
            ...schema,
          }}
          countries={countriesAbbreviation}
          inputComponent={CustomInput}
        />
        {error && (
          <div
            className={`absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none`}
          >
            <ExclamationCircleIcon
              className="h-5 w-5 text-red-500"
              aria-hidden="true"
            />
          </div>
        )}
      </div>
      {InputErrors(error, schema, null, label)}
    </div>
  );
};
export default PhoneNumberInput;
